import { ActionType } from './../constants';

const initialState = {
  signin: [],
  loading: false,
  error: null,
  msg: null,
};

const ContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.CONTENT_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ActionType.CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        contentInfo: action.payload.contentData,
      };

    case ActionType.CONTENT_ERROR:
      return {
        ...state,
        loading: false,
        contentInfo: action.payload.error,
      };

    default:
      return state;
  }
};

export { ContentReducer };
